type Props = {
  hash: string | undefined;
};

export function ViewTransaction({ hash }: Props) {
  if (!hash) {
    return;
  }

  return (
    <a
      href={`${process.env.NEXT_PUBLIC_L1_EXPLORER_URL}/tx/${hash}`}
      target="_blank"
      rel="noreferrer"
      className="-mt-2 text-center text-white/80 underline"
    >
      View on block explorer
    </a>
  );
}
